import { ArrayInput, ArrayInputProps, SimpleFormIterator, SimpleFormIteratorProps } from 'react-admin';
// import GrapesjsInput from '../GrapesjsInput';

const SimpleFormSxGrid4 = {
    "& ul": {
        display: 'grid',
        rowGap: '5px',
        gridTemplateColumns: '25% 25% 25% 25%',
    },
}

interface ArrayFormProps extends Omit<ArrayInputProps, "children"> {
    children: React.ReactNode,
    simpleFormIteratorProps?: Partial<SimpleFormIteratorProps>,
    grid: 0 | 4
}

const ArrayForm = ({ children, simpleFormIteratorProps, grid, ...props }: ArrayFormProps) => {
    return (
        <ArrayInput fullWidth {...props}>
            <SimpleFormIterator fullWidth {...{
                ...simpleFormIteratorProps,
                sx: {
                    ...simpleFormIteratorProps?.sx,
                    ...(grid === 4 ? SimpleFormSxGrid4 : {}),
                    "& li:odd": {
                        backgroundColor: 'white',
                    },
                    "& li:even": {
                        backgroundColor: 'lightgray',
                    },
                    "& .RaSimpleFormIterator-action": {
                        visibility: 'visible',
                    },
                    "& .RaSimpleFormIterator-line": {
                        borderBottom: 'none',
                    },
                }
            }}>
                {children}
            </SimpleFormIterator>
        </ArrayInput>
    )
}

ArrayForm.defaultProps = {
    grid: 4,
}

export default ArrayForm;